import Convertersadd from "./convertersadd";
import Trending from "./trending";
import Typingadd from "./typingadd";
import './home.css';

export default function Home() {  
 

  return (
    <>
      <div>
        <div id="ad-container">
        
        <Trending/>
        <div id="homeads">
        <Typingadd/>
        <Convertersadd/>
        </div>
      </div>
      </div>
    </>
  );
}
